const LargeWeekViewHorizontalLines = ({containerOffset}) => {
    return (
        <div className="col-start-1 col-end-2 row-start-1 grid divide-y divide-gray-100" style={{ gridTemplateRows: 'repeat(48, minmax(2.5rem, 1fr))' }}>
            <div ref={containerOffset} className="row-end-1 h-7"></div>
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                12AM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                1AM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                2AM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                3AM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                4AM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                5AM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                6AM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                7AM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                8AM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                9AM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                10AM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                11AM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                12PM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                1PM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                2PM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                3PM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                4PM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                5PM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                6PM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                7PM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                8PM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                9PM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                10PM
              </div>
            </div>
            <div />
            <div className='border-solid border-l-0 border-r-0'>
              <div className="sticky left-0 z-20 -mt-2.5 -ml-14 w-14 pr-2 text-center text-xs leading-5 text-gray-600 font-bold">
                11PM
              </div>
            </div>
            <div />
        </div>
    )
}
export default LargeWeekViewHorizontalLines